// test1018
(1018 && 0);
